import { render, staticRenderFns } from "./GuestFavoritesList.vue?vue&type=template&id=754f827b&"
import script from "./GuestFavoritesList.vue?vue&type=script&lang=js&"
export * from "./GuestFavoritesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports